import {
  API_CARD_GET_LIMITS,
  API_CARD_GET_STATUS,
  API_CARD_SEND_EMAIL,
  API_CARD_SET_LIMITS,
  API_CARD_TOPUP,
  API_CARD_UPDATE_STATUS,
  API_CARDS_ADD_CARD,
  API_CARDS_CREATE_CREDIT_CARD,
  API_CARDS_CREATE_PHYSICAL_CARD,
  API_CARDS_LIST_PHYSICAL,
  API_CARDS_LIST_VIRTUAL,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const getVirtualCardsListAPI = ({ limit, offset, from, to, agent }) => {
  return axiosMiddleware({
    method: "get",
    url: `/${API_CARDS_LIST_VIRTUAL}?limit=${limit}&offset=${offset}&agentId=${agent}&from=${from}&to=${to}`,
  });
};
export const getPhysicalCardsListAPI = ({ limit, offset, from, to, agent }) => {
  return axiosMiddleware({
    method: "get",
    url: `/${API_CARDS_LIST_PHYSICAL}?limit=${limit}&offset=${offset}&agentId=${agent}&from=${from}&to=${to}`,
  });
};
export const getCardsLimitsAPI = (cardId) => {
  return axiosMiddleware({
    method: "post",
    url: API_CARD_GET_LIMITS,
    data: {
      cardId,
    },
  });
};
export const setCardsLimitsAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: API_CARD_SET_LIMITS,
    data,
  });
};
export const updateCardsStatusAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: API_CARD_UPDATE_STATUS,
    data,
  });
};
export const getCardsStatusAPI = (cardId) => {
  return axiosMiddleware({
    method: "post",
    url: API_CARD_GET_STATUS,
    data: {
      cardId,
    },
  });
};

export const createCreditCardApi = ({
  currency,
  agent,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
}) => {
  let postData = {
    currency_id: currency,
    agent_id: agent,
    amount,
    email,
    english_first_name,
    persian_first_name,
    english_last_name,
    persian_last_name,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARDS_CREATE_CREDIT_CARD,
    data: postData,
  });
};
export const createPhysicalCardApi = ({
  currency,
  agent,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
  card_number,
  cvv2,
  expire_date,
}) => {
  let postData = {
    currency_id: currency,
    agent_id: agent,
    amount,
    email,
    english_first_name,
    persian_first_name,
    english_last_name,
    persian_last_name,
    card_number,
    cvv2,
    expire_date,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARDS_CREATE_PHYSICAL_CARD,
    data: postData,
  });
};
export const topupCardApi = ({ userId, walletId, amount }) => {
  let postData = {
    user_id: userId,
    wallet_id: walletId,
    amount: Number(amount).toFixed(2),
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARD_TOPUP,
    data: postData,
  });
};
export const sendEmailApi = ({
  token,
  un,
  persian_user_name,
  english_user_name,
  balance,
  postal_code,
}) => {
  let postData = {
    token,
    un,
    persian_user_name,
    english_user_name,
    balance,
    postal_code,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARD_SEND_EMAIL,
    data: postData,
  });
};

export const addCardApi = ({ email }) => {
  let postData = {
    email,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARDS_ADD_CARD,
    data: postData,
  });
};